import React from 'react';
import ServiceCard from './ServiceCard';

export default function Services() {
  const services = [
    {
      img: '/assets/home_inspection.avif',
      title: 'Home\ninspection',
      desc: 'Our home inspection service identifies areas needing special attention for a spotless home.',
      options: ['Home maintenance'],
    },
    {
      img: '/assets/cleaning_services.avif',
      title: 'Cleaning\nservices',
      desc: 'Professional cleaning for homes, offices, stores and more.',
      options: ['Condo', 'House', 'Office / Store'],
    },
  ];

  return (
    <section id='services' className='am-services-section am-use-dom-waves'>
      {/* Top wave (DOM-rendered to avoid mobile hairline seams) */}
      <div className='am-wave am-wave-top' aria-hidden>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 120' preserveAspectRatio='none'>
          <path fill='#ffffff' d='M0,72 C360,30 720,120 1440,72 L1440,0 L0,0 Z' />
        </svg>
      </div>
      <div className='am-container am-services-inner'>
        <h2 className='am-results-title'>OUR SERVICES</h2>
        <p className='am-services-lead'>
          More than just cleaning—we ensure your home or office stays spotless, well-maintained, and ready for what's
          next. <strong>Discover our professional services</strong> designed for peace of mind and long-term savings.
        </p>

        <div className='am-services-cards'>
          {services.map((s, i) => (
            <ServiceCard key={i} img={s.img} title={s.title} desc={s.desc} options={s.options} />
          ))}
        </div>

        <div className='am-services-cta am-services-cta-over-wave'>
          <button className='am-chip am-chip-primary' data-open-quote>
            REQUEST A FREE QUOTE
          </button>
        </div>
      </div>
      {/* Bottom wave (DOM-rendered) */}
      <div className='am-wave am-wave-bottom' aria-hidden>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 120' preserveAspectRatio='none'>
          <path fill='#ffffff' d='M0,48 C360,90 720,0 1440,48 L1440,120 L0,120 Z' />
        </svg>
      </div>
    </section>
  );
}
